module.exports = __webpack_public_path__ + "static/media/karachi-r2.9cc739fe.svg";